import h from "../core/createElement";

export default function Spinner({ black = true }) {
    return (
        <section class={"spinner " + (black ? "black" : "")}>
            <article class="loader">
            </article>
        </section>
    );
};